import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    title: "",
    categories: [],
    variations: [],
    activeVariation: {
        id: null,
        price: "",
        value: ""
    },
    UI: {
        showSizeDropdown: false,
        showATCConfirmation: false
    }
};

const singleProductSlice = createSlice({
    name: "singleProduct",
    initialState,
    reducers: {
        setSingleProduct: (state, action) => {
            state.title = action.payload.title;
            state.mainImageSrc = action.payload.mainImageSrc;
            state.variations = action.payload.variations;
            state.UI.showSizeDropdown = false;
            state.UI.showATCConfirmation = false;
            state.categories = action.payload.categories;
            state.activeVariation = {
                id: null,
                price: "",
                value: ""
            };
        },
        setActiveVariation: (state, action) => {
            state.activeVariation.id = action.payload.id;
            state.activeVariation.price = action.payload.price;
            state.activeVariation.value = action.payload.value;
        },
        toggleSizeDropdown: (state, action) => {
            state.UI.showSizeDropdown = action.payload.visible;
        },
        toggleATCConfirmation: (state, action) => {
            state.UI.showATCConfirmation = action.payload.visible;
        }
    }
});

export const { setSingleProduct, setActiveVariation, toggleSizeDropdown, toggleATCConfirmation } = singleProductSlice.actions;
export default singleProductSlice.reducer;